import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setHeaderNavLocation, setHeaderStyle, setScrollDirection, forceCollapseMenu } from './../../redux/actions';
import HeaderNav from  './HeaderNav';
import CategoryNavWrapper from './../filter-pages/CategoryNavWrapper';
import { breakpoints } from './../../styles/theme.json';
import { scrollWatcher } from './../../scripts';

class HeaderLayout extends Component {
  _headerUpdate(location) {
    this.props.updateHeaderNav(location);
    this.props.updateHeaderStyle(location);
    this._closeHandler = this._closeHandler.bind(this);
    this._openHandler = this._openHandler.bind(this);
  }

  _closeHandler() {
    this.props.setScrollDirection('scrolling-down');
    this.props.forceCollapseMenu();
  };

  _openHandler() {
    this.props.setScrollDirection('scrolling-up');
    this.props.forceCollapseMenu();
  };

  componentWillReceiveProps(nextProps) {
    this._headerUpdate(nextProps.location.pathname);
  }

  componentWillMount() {
    this._headerUpdate(this.props.location.pathname);
    scrollWatcher(
      () => this._closeHandler(),
      () => this._openHandler(),
      15 // DELAY - AMOUT OF SCROLL
    );
  }

  render(){
    return (
      <header
        style={{zIndex:'1000'}}
        className={(this.props.isOpen)
          ? `${this.props.headerStyle} nav-drop ${this.props.scrollDirection} ${this.props.belowHero} ${this.props.video_header_state}`
          : `${this.props.headerStyle} ${this.props.scrollDirection} ${this.props.belowHero} ${this.props.video_header_state}`
        }>
        <HeaderNav/>
        {(this.props.cat_page && (this.props.belowHero != null) && (this.props.window_width >= breakpoints.desktop))
          && <div id={'category-menu-wrapper-header'}><CategoryNavWrapper/></div>
        }
      </header>
    );
  };
};

export default connect(
  state => ({
    headerStyle: state.header_style,
    scrollDirection: state.scroll_direction,
    belowHero: state.scroll_state.cat_menu_wrapper,
    isOpen: state.menu_state,
    cat_nav: state.category_nav,
    cat_page: state.category_nav_page,
    window_width: state.window_dimensions.window_width,
    video_header_state: state.video_state.header_style
  }),
  dispatch => ({
    updateHeaderNav: (location) => dispatch(setHeaderNavLocation(location)),
    updateHeaderStyle: (location) => dispatch(setHeaderStyle(location)),
    setScrollDirection: (direction) => dispatch(setScrollDirection(direction)),
    forceCollapseMenu: () => dispatch(forceCollapseMenu())
  })
)(HeaderLayout);



// WEBPACK FOOTER //
// ./src/components/header/HeaderLayout.js